import api from './api';

export interface Guest {
  id: string;
  wedding_id: string;
  first_name: string;
  last_name: string;
  phone: string | null;
  email: string | null;
  num_invited: number;
  num_expected_to_attend: number;
  category_level1_id: string | null;
  category_level2_id: string | null;
  notes: string | null;
  dietary_restriction: string | null;
  dietary_restriction_note: string | null;
  created_at: string;
  updated_at: string;
}

export interface GuestFormData {
  first_name: string;
  last_name: string;
  phone?: string | null;
  email?: string | null;
  num_invited?: number;
  num_expected_to_attend?: number;
  category_level1_id?: string | null;
  category_level2_id?: string | null;
  notes?: string | null;
  dietary_restriction?: string | null;
  dietary_restriction_note?: string | null;
}

export const getGuests = (params?: Record<string, string>) =>
  api.get<Guest[]>('/guests', { params });
export const getGuest = (id: string) => api.get<Guest>(`/guests/${id}`);
export const createGuest = (data: GuestFormData) => api.post<Guest>('/guests', data);
export const updateGuest = (id: string, data: Partial<GuestFormData>) =>
  api.put<Guest>(`/guests/${id}`, data);
export const deleteGuest = (id: string) => api.delete(`/guests/${id}`);
export const exportGuestsCsv = (params?: Record<string, string>) =>
  api.get('/guests/export/csv', { params, responseType: 'blob' });
